import React from 'react';
import { Button } from 'react-bootstrap';
import { useSignInWithGoogle } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import auth from '../../firebase.init';

const SocialLogin = () => {
     const navigate = useNavigate()

     const [signInWithGoogle, user, loading, error] = useSignInWithGoogle(auth);
     if (user) {
          navigate('/')
     }
     let errorElement;
     if (error) {

          errorElement = <div>
               <p className='text-danger'>Error: {error.message}</p>
          </div>

     }

     return (
          <div>
               <p>{errorElement}</p>
               <Button onClick={() => signInWithGoogle()} className='w-50' variant="primary" >
                    google
               </Button>
          </div>
     );
};

export default SocialLogin;